import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-logo',
  templateUrl: './shared-logo.component.html',
  styleUrls: ['./shared-logo.component.scss'],
})
export class SharedLogoComponent {
  @Input() logo_class?: string = 'hmn-shared-logo__m';
  @Input() logo_src?: string = '../../../assets/imgs/logo/logo_dark_short.svg';
}
